import { z } from 'zod';

export const NOTIFICATION_CHANNELS = ['EMAIL', 'SMS', 'PUSH', 'WHATSAPP'] as const;
export type NotificationChannel = (typeof NOTIFICATION_CHANNELS)[number];

export const listNotificationLogsQuerySchema = z.object({
  cursor: z.string().nullish(),
  limit: z.coerce.number().int().min(1).max(100).default(25),
  channel: z.enum(NOTIFICATION_CHANNELS).nullish(),
});
export type ListNotificationLogsQuery = z.infer<typeof listNotificationLogsQuerySchema>;

export interface NotificationLogResponse {
  readonly id: string;
  readonly channel: NotificationChannel;
  /** Already masked server-side — never the full address or number. */
  readonly recipientMasked: string;
  readonly subject: string | null;
  readonly provider: string;
  readonly accepted: boolean;
  readonly failureReason: string | null;
  readonly sentAt: string;
}
